/** @jsx jsx */
import { ClassAttributes, Fragment } from 'react';
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';

import { Button, RightArrow, } from '@argo/ui-elements';
import { colors, typography, } from '@argo/principles';
import ConsumerReview from '../containers/ConsumerReview';
import ConsumerRatings from '../../sew-common/components/ConsumerRatings';
import { ConsumerReviewAndRating, Vehicle, } from '../../sew-core/types';

const Container = styled.div`
  width: 100%;
`;

const ParagraphContainer = styled.div`
  padding: 8px 0;
  h4 {
    font-family: Open Sans Regular, sans-serif;
  }
`;

const MoreReviewsLink = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  padding-top: 22px;
`;

const MoreReviewsLinkDescription = styled.div`
  font-size: 10px;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.black};
  font-weight: ${typography.weight.semiBold};
  padding-left: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  border: none;
  border-bottom: 1px solid #ddd;
  width: 100%;
  padding-top: 21px;
`;

interface ConsumerReviewProps extends ClassAttributes<any> {
  consumerReviewAndRating: ConsumerReviewAndRating;
  vehicle: Vehicle;
  shouldEnableKBBLink: boolean;
  onConsumerReviewsMoreReviewsClick: () => void;
}

export default ({ vehicle, consumerReviewAndRating, shouldEnableKBBLink, onConsumerReviewsMoreReviewsClick, }: ConsumerReviewProps,): JSX.Element => {
  const { numberOfReviews, consumerReviews, moreReviewsLink, } = consumerReviewAndRating;
  let showMoreReviewsLink = true;
  let displayedReviews = 3;
  if (numberOfReviews <= displayedReviews) {
    showMoreReviewsLink = false;
    displayedReviews = numberOfReviews;
  }

  if(numberOfReviews === 0){
    return(
      <Container>
        There are no reviews for this vehicle.
      </Container>
    )
  }

  return (
    <Container>
      <ConsumerRatings
        vehicle={vehicle}
        consumerReviewAndRating={consumerReviewAndRating}
      />
      <ParagraphContainer style={{ paddingBottom: '16px', }}>
        {consumerReviews.slice(0, displayedReviews,).map((review: any, index: number,) => (
          <ConsumerReview index={index} key={index} overallRating={review.overallRating} title={review.title} nickName={review.nickName} submissionDate={review.submissionDate} text={review.text} />
        ),)}
        {shouldEnableKBBLink ? (
          <Fragment>
            <Divider style={{ display: showMoreReviewsLink ? 'flex' : 'none', }} />
            <MoreReviewsLink style={{ display: showMoreReviewsLink ? 'flex' : 'none', }}>
              <Button
                href={moreReviewsLink}
                target="_blank"
                buttonType="text"
                enableCapitalize={false}
                text="More&nbsp;Reviews"
                onClick={(): void => { onConsumerReviewsMoreReviewsClick(); }}
              >
                <RightArrow size="10" color="brightBlue" />
              </Button>
              <MoreReviewsLinkDescription>{`1 – ${displayedReviews} of ${numberOfReviews} reviews`}</MoreReviewsLinkDescription>
            </MoreReviewsLink>
          </Fragment>
        )
          : ('')}
      </ParagraphContainer>
    </Container>
  );
};
